import ILanguage from '@/assets/lang/ILanguage';

const pt: ILanguage = {
  generic: {
    developedBy: 'Desenvolvido por',
    loading: 'Carregando, Aguarde',
    anonymousEvaluation: 'Avaliar em anonimato',
    acceptanceContact: 'Aceito ser contatado',
    chooseTheChannelToContact: 'Escolha a melhor forma para entrarmos em contato',
    whatsapp: 'Whatsapp',
    phone: 'Telefone',
    email: 'E-mail',
    like: 'Gostei',
    back: 'Voltar',
    skipAnswer: 'Não responder',
    scoreOption: 'Nota {score}',
    noScore: 'Nenhuma nota',
    progress: 'Progresso da pesquisa',
    paidSurveyFrameTitle: 'Pesquisas remuneradas',
    dislike: 'Não gostei',
    forceAnonymousEvaluation: 'Pesquisa anônima',
  },

  preEnrichment: {
    title: 'Pesquisa de Satisfação',
    subtitle: 'Preencha as informações abaixo para iniciar a pesquisa:',
    error: 'Houve um problema ao cadastrar, tente novamente.',
  },

  enrichment: {
    title: 'Insira as informações abaixo',
    requiredField: 'Campo obrigatório',
    invalidDocument: 'Documento inválido',
    invalidEntityDocument: 'CNPJ Inválido',
    invalidDate: 'Data Inválida',
    labelName: 'Nome Completo',
    PlaceholderName: 'Nome Sobrenome',
    labelEmail: 'Email',
    labelGender: 'Sexo',
    maleGender: 'Masculino',
    femaleGender: 'Feminino',
    otherGender: 'Outro',
    zipcode: 'CEP',
    state: 'Estado',
    statePlaceholder: 'SP',
    city: 'Cidade',
    cityPlaceholder: 'São José dos Campos',
    neighbor: 'Bairro',
    neighborPlaceholder: 'Jardim Veneza',
    address: 'Logradouro',
    addressPlaceholder: 'Rua João das Neves',
    number: 'Número',
    complement: 'Complemento',
    labelPhone: 'Telefone',
    labelBirth: 'Data de Nascimento',
    labelDocument: 'CPF',
    labelEntityDocument: 'CNPJ',
    labelDocumentOrEntityDocument: 'CPF ou CNPJ',
    maskDocument: '###.###.###-##',
    start: 'INICIAR',
    finish: 'FINALIZAR',
    skip: 'pular',
    send: 'ENVIAR',
  },

  errorMessages: {
    opsText: 'Ops!',
    unexpectedError: 'Ops! Avaliação não disponível no momento',
    unexpectedErrorDetails: 'Avaliação não disponível no momento',
    missingItem: 'Faltou dar opinião sobre algum item',
    missingScore: 'Escolha uma nota de 0 à 10',
    missingScoreCSAT: 'Escolha uma nota de 1 à 5',
    missingScoreCES: 'Escolha uma nota de 1 à 7',
    surveyAlreadyDone: 'Esta avaliação já foi realizada',
    surveyAlreadyDoneDetails: 'Infelizmente não é possível realizar esta avaliação novamente.',
    surveyNotFound: 'Ops! Avaliação não encontrada',
    surveyNotFoundDetails:
      'Infelizmente ocorreu uma falha, mas não deixe de avaliar as próximas pesquisas. Sua opinião é muito importante para nós.',
    surveyExpired: 'O período para realizar esta avaliação expirou',
    surveyExpiredDetails: 'Infelizmente esta avaliação não está mais disponível.',
    surveyInvalidScore: 'Ops! Nota inválida',
    surveyInvalidScoreDetails: 'Você informou uma nota inválida para este tipo de pesquisa.',
    surveyInativeJourney: 'Ops! Avaliação não disponível no momento',
    surveyInativeJourneyDetails: 'Avaliação não disponível no momento',
    SURVEY_SUSPENDED: 'Campanha encerrada',
    SURVEY_SUSPENDEDDetails: 'Não deixe de nos avaliar em sua próxima experiência. Sua opinião é muito importante',
    surveyBlocked: 'Ops! Avaliação não disponível no momento',
    surveyBlockedDetails: 'Avaliação não disponível no momento',
    'Survey blocked': 'Ops! Avaliação não disponível no momento',
    'Survey blockedDetails': 'Avaliação não disponível no momento',
    'survey blocked': 'Ops! Avaliação não disponível no momento',
    'survey blockedDetails': 'Avaliação não disponível no momento',
    'Journey is required for this instance': 'Jornada não definida',
    'Journey is required for this instanceDetails': 'Por favor informe a jornada para realizar a pesquisa',
    'Transaction already rated': 'Esta avaliação já foi realizada',
    'Transaction already ratedDetails': 'Infelizmente não é possível realizar esta avaliação novamente.',
  },

  unsubscribe: {
    title: 'Que pena!',
    titleDescription:
      'Nossa intenção sempre foi lhe oferecer a melhor experiência possível. Ao se descadastrar, você não receberá mais as pesquisas de satisfação da ',
    descriptionAfter: '  será descadastrado.',
    error: 'Não foi possível descadastrar o email',
    thanks: 'Obrigado',
    form: {
      question: 'Por favor, informe o motivo de sua saída:',
      answer1: 'Não desejo mais dar minha opinião',
      answer2: 'Estou recebendo muitos contatos',
      answer3: 'Esta pesquisa não é do meu interesse',
      answer4: 'Outro motivo',
      send: 'enviar',
    },
  },

  selectBelow: 'Selecione um dos botões abaixo',
  totallyDisagree: 'Extremamente Difícil',
  Disagree: 'Muito Difícil',
  partiallyDisagree: 'Razoavelmente Difícil',
  Neutral: 'Neutro',
  partiallyAgree: 'Razoavelmente Fácil',
  Agree: 'Muito Fácil',
  stronglyAgree: 'Extremamente Fácil',
  howCouldWeImprove: 'Como podemos melhorar?',
  leaveYourSuggestionHere: 'Deixe sua sugestão aqui.',
  requiredLabel: 'Obrigatório',
  isRequiredField: 'É necessário preencher este campo',
  clickOnButton: 'Clique no botão',
  skipOrClickOnButton: 'Pule ou clique no botão',
  toNotAnswerQuestion: 'para não responder uma questão',
};

export default pt;
